import {LocationSnapshot} from '../pages/my-vessels-v2/listing/hooks/use-location-snapshot'
import {AxiosRequestConfig} from 'axios'
import {REST} from '..'
import {isArray, isString} from 'lodash'
export type {Location} from '../store/state/locations/state'

const LOCATION_SNAPSHOT_URL = '/medulla-onboard/api/v1/config/snapshot'
const LOCATION_SNAPSHOT_LOAD_URL = '/medulla-onboard/api/v1/config/snapshot/load'

export const fetchLocationSnapshots = async () => {
    const response = await REST.get(LOCATION_SNAPSHOT_URL)
    if (!response?.data) {
        throw new Error('Invalid response structure')
    }
    return response.data
}

export const updateLocationSnapshot = async (snapshot: LocationSnapshot) => {
    const response = await REST.post(LOCATION_SNAPSHOT_LOAD_URL, snapshot)
    if (!response?.data) {
        throw new Error('Invalid response structure')
    }
    return response.data
}

const OTSM_VESSELS_ENDPOINT = '/vessels/api/v1/nodes/locations/otsm'
const VESSELS_URL = '/vessels/api/v1/nodes/locations'

export interface OtsmVesselResponse {
    type: string
    description: string
    customerLocationCode: string
}

export interface OtsmVesselRequest extends Partial<OtsmVesselResponse> {}

export interface ErrorDetails {
    instance: string
    detail: string
    field?: string
}

export interface OtsmVesselRequestError {
    message: string
    errors: ErrorDetails[]
}

export interface OtsmVesselLookupResponse {
    found: OtsmVesselResponse[]
    missing: string[]
}

export function isOtsmVesselRequestError(v: unknown): v is OtsmVesselRequestError {
    const u = v as OtsmVesselRequestError
    return isString(u.message) && isArray(u.errors)
}

export function validateOtsmOnlyVessels(body: OtsmVesselRequest[], config?: AxiosRequestConfig) {
    return REST.post(`${OTSM_VESSELS_ENDPOINT}/validate`, body, {
        ...config,
    })
}

export function createOtsmOnlyVessel(body: OtsmVesselRequest, config?: AxiosRequestConfig) {
    return REST.post(`${OTSM_VESSELS_ENDPOINT}`, body, {
        ...config,
    })
}

export function lookupOtsmOnlyVessel(imos: string[], config?: AxiosRequestConfig) {
    const params = new URLSearchParams()
    imos.forEach((imo) => {
        params.append('imos', imo)
    })

    return REST.get<OtsmVesselLookupResponse>(`${OTSM_VESSELS_ENDPOINT}/lookup`, {
        ...config,
        params,
    })
}

// This only fetches `ACTIVE` locations by default
export async function fetchVessels(): Promise<Location[]> {
    const res = await REST.get<Location[]>(VESSELS_URL)

    return res.data
}
